import axios from "axios";
import * as common from "app/common";
const BASE_URL = common.WEB_API_URL;
const makeGet = path => () => axios.get(BASE_URL + path);

export const fetchAllMenus = makeGet("/v1/app/ui/menu");
